"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatistics = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const useDeepMemo_1 = require("../../../hooks/useDeepMemo");
const common_styled_components_1 = require("../../common-styled-components");
const NumberKPI_1 = __importDefault(require("./NumberKPI"));
const theme_1 = require("../../../theme");
const LineChart_1 = __importDefault(require("../LineChart"));
const getUnitAnalysis = (transactions) => {
    if (transactions.length === 0) {
        return {
            averagePrice: 0,
            totalTransactionUnits: 0,
            totalTransactionPrice: 0,
        };
    }
    const totalTransactionUnits = transactions.reduce((sum, txn) => sum + txn.quantity, 0);
    const totalTransactionPrice = transactions.reduce((sum, txn) => sum + txn.total_to_be_paid, 0);
    const averagePrice = totalTransactionPrice / totalTransactionUnits;
    return {
        averagePrice,
        totalTransactionUnits,
        totalTransactionPrice,
    };
};
const TransactionStatistics = ({ transactions, year, }) => {
    const [totalAnalysis, monthlyAnalysis] = (0, useDeepMemo_1.useDeepMemo)(() => {
        const totalAnalysis = getUnitAnalysis(transactions);
        const transactionsPerMonth = (0, lodash_1.groupBy)(transactions, (txn) => {
            const date = new Date(txn.transaction_date);
            return `${date.getFullYear()}-${date.getMonth() + 1}`;
        });
        const transactionTimeline = Object.entries(transactionsPerMonth)
            .map(([month, txns]) => {
            return {
                month,
                ...getUnitAnalysis(txns),
            };
        })
            .sort((a, b) => (new Date(a.month) < new Date(b.month) ? -1 : 1));
        return [totalAnalysis, transactionTimeline];
    }, [transactions]);
    // Placeholder implementation
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 3, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "Total Transactions", value: (totalAnalysis.totalTransactionUnits / 1000).toFixed(2), color: theme_1.theme.colors.darkBlue, unit: "KtCO₂e" }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "Total Price", value: (totalAnalysis.totalTransactionPrice / 1000000).toFixed(2), color: theme_1.theme.colors.darkBlue, unit: "M$" }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "Average Unit Price", value: totalAnalysis.averagePrice.toFixed(2), color: theme_1.theme.colors.darkBlue, unit: "$ / tCO₂e" }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 2, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: `Monthly Transaction Units in ${year}`, data: [
                                {
                                    name: "Total Units",
                                    color: theme_1.theme.colors.darkBlue,
                                    data: monthlyAnalysis.map((entry) => ({
                                        date: new Date(`${entry.month}-01`),
                                        value: entry.totalTransactionUnits,
                                    })),
                                },
                            ], unit: "tCO\u2082e" }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: `Monthly Unit price in ${year}`, data: [
                                {
                                    name: "Monthly Average Unit Price",
                                    color: theme_1.theme.colors.darkBlue,
                                    data: monthlyAnalysis.map((entry) => ({
                                        date: new Date(`${entry.month}-01`),
                                        value: entry.averagePrice,
                                    })),
                                },
                            ], unit: "$ / tCO\u2082e" }) })] })] }));
};
exports.TransactionStatistics = TransactionStatistics;
